const initialState = {
  active: false,
  multiple: false,
  chat: false,
  selectedIndexes: null,
  selected_value: null,
  products: null,
  resolve: null,
  reject: null,
};

const state = Object.assign({}, initialState);

const mutations = {
  ACTIVATE: (state, payload) => {
    Object.assign(state, payload);
  },
  DEACTIVATE: (state) => {
    state = Object.assign(state, initialState);
  },
};

const actions = {
  select: (
    { commit },
    { active, multiple, chat, selectedIndexes, selected_value, products }
  ) => {
    if (!active) {
      multiple = false;
      chat = false;
      selectedIndexes = null;
      products = null;
      selected_value = null;
    } else {
      selectedIndexes == null ? (selectedIndexes = []) : selectedIndexes;
      products == null ? (products = []) : products;
    }
    return new Promise((resolve, reject) => {
      commit("ACTIVATE", {
        active,
        multiple,
        chat,
        selectedIndexes,
        selected_value,
        products,
        resolve,
        reject,
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
